$(document).ready(function(){
  var lastFocusedBeforeOpenStoresModal = null;
  var storesKeydownHandler = null;

  function getStoresModalFocusables() {
    var modal = document.querySelector('.stores-modal');
    if (!modal) return [];
    return Array.prototype.slice.call(modal.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter(function (el) {
      var style = window.getComputedStyle(el);
      return style.display !== 'none' && style.visibility !== 'hidden';
    });
  }

  function openStoresModal() {
    var modal = document.querySelector('.stores-modal');
    if (!modal) return;
    lastFocusedBeforeOpenStoresModal = document.activeElement;
    modal.classList.add('active');
    modal.setAttribute('aria-hidden', 'false');
    // Mover foco al botón cerrar (patrón estándar)
    setTimeout(function () {
      var closeBtn = modal.querySelector('.close-stores-modal');
      if (closeBtn) closeBtn.focus();
      else {
        var focusables = getStoresModalFocusables();
        if (focusables[0]) focusables[0].focus();
      }
    }, 100);
    // Focus trap + Esc
    storesKeydownHandler = function (e) {
      if (!modal.classList.contains('active')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeStoresModal();
        return;
      }
      if (e.key === 'Tab') {
        var focusables = getStoresModalFocusables();
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        var active = document.activeElement;
        if (!modal.contains(active)) {
          e.preventDefault();
          first.focus();
          return;
        }
        if (e.shiftKey && active === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && active === last) {
          e.preventDefault();
          first.focus();
        }
      }
    };
    document.addEventListener('keydown', storesKeydownHandler, true);
  }

  function closeStoresModal() {
    var modal = document.querySelector('.stores-modal');
    if (!modal) return;
    modal.classList.remove('active');
    modal.setAttribute('aria-hidden', 'true');
    if (storesKeydownHandler) {
      document.removeEventListener('keydown', storesKeydownHandler, true);
      storesKeydownHandler = null;
    }
    if (lastFocusedBeforeOpenStoresModal && typeof lastFocusedBeforeOpenStoresModal.focus === 'function') {
      try { lastFocusedBeforeOpenStoresModal.focus(); } catch (_) {}
    }
    lastFocusedBeforeOpenStoresModal = null;
  }

  // Expuesto para que otros componentes (p.ej. el aviso de pickup en la ficha)
  // puedan abrir el selector de tiendas sin duplicar la logica de foco.
  window.openStoresModal = openStoresModal;
  window.closeStoresModal = closeStoresModal;

  // Version escritorio
  $("header .row.top .content-store").click(function(){
    openStoresModal();
  });
  $(".close-stores-modal").click(function(){
    closeStoresModal();
  });

  // Version movil
  $("header .row.nav .content-store").click(function(){
    $("header .row.nav .content-store").addClass("hidden");
    $("header .row.nav .content-language").addClass("hidden");
    $("header .content-nav").removeClass("active");
    openStoresModal();
  });

})